import { AccessType } from '@sonar-software/sonar-core';
import { enumStringKeys } from '@sonar-software/sonar-ts-lib';
import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '../@arch/lib';
import React from 'react';

import { accessTypeLabels, AccessTypeTag } from '@security/access/AccessTypeTag';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { FilterOption, OptionFilter } from '@periscopes/general/filters';

const options: Array<FilterOption> = enumStringKeys(AccessType)
	.filter((key) => AccessType[ key ] !== AccessType.Object)
	.map((key) => ({
		label: accessTypeLabels[ key ],
		value: AccessType[ key ]
	}));

export const AccessTypeFilter: FilterComponent<Array<AccessType> | undefined> = (props) => {
	const { format, id, label, onChange, value } = props;

	return (
		<FilterComponent
			{ ...props }
			tagProps={ {
				clearValue: undefined,
				label: COPY_SPECIFIC.ACCESS_TYPES,
				value: value
					?.map((entry) => accessTypeLabels[ entry ])
					.join(', ')
			} }>
			<OptionFilter
				className='filter'
				getPopupContainer={ getDirectParent }
				id={ getFilterId(String(id)) }
				maxTagCount='responsive'
				mode='multiple'
				onChange={ (selection: Array<AccessType>) => {
					onChange({
						[ id ]: {
							format,
							value: selection
						}
					});
				} }
				options={ options }
				placeholder={ PLACEHOLDERS_COPY.FILTER_BY(label) }
				showArrow
				tagRender={ (option) => <AccessTypeTag accessType={ option.value } /> }
				value={ value } />
		</FilterComponent>
	);
};
